import { atom } from 'jotai'
import { ThemeName } from 'sierra-ui/theming/legacy-theme'

export const tablePreviewThemeAtom = atom<ThemeName | undefined>(undefined)
